<app-banner [heading]="'OUR INFRA - PHYSICS LAB'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
   <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 ">
            
              <img src="assets/img/infra/sciencelabs/physics-lab-4.jpg" class="img-fluid" alt="best school in kurukshetra">
            </div>

         <div class="col-lg-6  pt-5 pt-lg-0">
           <!-- <div class="about-content"> -->
              
              
              <p><br>The school boasts of well-equipped Physics, Chemistry &amp; Biology laboratories for the students. 
			  <br>Performing experiments help students learn techniques and reinforce textbook concepts. <br><br>There is a
			  tremendous competition and we are preparing our students with latest technology in the school.
			  
			  </p>
              
            </div>
          </div> 
      </div>
	</section><!-- End About Section -->
	

	
	
    
    
  </main>